import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import useTinyViewer from 'hooks/use-tiny-viewer';
import Frame from 'react-frame-component';
const RichTextViewer = ({ id, content, height, customInitialContent, getFrameRef, getHeight }) => {
    const { createInitialContent } = useTinyViewer(true);
    const initialContent = customInitialContent !== null && customInitialContent !== void 0 ? customInitialContent : createInitialContent();
    const [frameRef, setFrameRef] = useState();
    useEffect(() => {
        iframeReady();
    }, [height, id]);
    useEffect(() => {
        /**Helps the parent to known when the frame is rendered */
        if (getFrameRef) {
            getFrameRef(frameRef);
        }
    }, [frameRef]);
    useEffect(() => {
        const iframe = document.getElementById(id);
        iframe.onload = () => {
            setFrameRef(iframe);
        };
    }, []);
    const iframeReady = () => {
        const iframe = document.getElementById(id);
        const iframeWindow = iframe.contentWindow;
        if (iframeWindow === null || iframeWindow === void 0 ? void 0 : iframeWindow.document.body) {
            let calculatedHeight = iframeWindow.document.body.scrollHeight;
            calculatedHeight = calculatedHeight + 50;
            if (getHeight) {
                getHeight(calculatedHeight);
            }
            if (height && height < calculatedHeight) {
                iframe.height = height + 'px';
                return;
            }
            iframe.height = calculatedHeight + 'px';
        }
    };
    return (_jsx(Frame, Object.assign({ id: id, contentDidMount: iframeReady, initialContent: initialContent, mountTarget: "#mountTarget" }, { children: _jsx("div", { className: "mce-content-body", dangerouslySetInnerHTML: { __html: content !== null && content !== void 0 ? content : '' } }, void 0) }), void 0));
};
export default RichTextViewer;
